import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate, faChalkboardTeacher, faClipboardList } from '@fortawesome/free-solid-svg-icons';

const BeneficiosSection = () => (
  <section id="diferenciais" className="benefits">
    <h2 className='titulo-secao'>Por que escolher nosso colégio?</h2>
    <div className="benefit-cards centralizar-div">
      <div className="card-mat">
        <div className="card-content-mat">
          <FontAwesomeIcon icon={faUserGraduate} className="icon" />
          <p>Nossos alunos têm os melhores resultados acadêmicos e formação integral.</p>
        </div>
        <div className='image-content-mat'>
          <img src="assets/images/landing/1.JPEG" className="card-image" alt="Alunos do Colégio Líder" />
        </div>
      </div>
      <div className="card-mat">
        <div className="card-content-mat">
          <FontAwesomeIcon icon={faChalkboardTeacher} className="icon" />
          <p>Contamos com uma equipe altamente qualificada e dedicada ao aprendizado de cada aluno.</p>
        </div>
        <div className='image-content-mat'>
          <img src="assets/images/landing/2.jpg" className="card-image" alt="Equipe de professores do Colégio Líder" />
        </div>
      </div>
      <div className="card-mat">
        <div className="card-content-mat">
          <FontAwesomeIcon icon={faClipboardList} className="icon" />
          <p>Ambientes pensados para o desenvolvimento completo dos estudantes.</p>
        </div>
        <div className='image-content-mat'>
          <img src="assets/images/landing/3.jpg" className="card-image" alt="Ambientes do Colégio Líder" />
        </div>
      </div>
    </div>
  </section>
);

export default BeneficiosSection;
